import classnames from 'classnames/bind'
import React from 'react'
import { GlobalGridPreset } from '~/@types/grid-preset'

import { useStyle } from '~/providers/StyleProvider'

import getStoreLocatorPageStaticPropsFunction from '~/data/store-locator-page-data'
import { StoreLocatorPageData } from '~/data/store-locator-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

function StoreLocator(props: StoreLocatorPageData) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  return (
    <>
      <div className={gridStyle}>
        <div className={cx(css.storeLocator)} id="swaven-storelocator" />
      </div>
    </>
  )
}

export default StoreLocator

export const getStaticProps = getStoreLocatorPageStaticPropsFunction()
